import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { historyProcessClassConfig } from './HistoryProcessClass.name';

/** 履歴処理区分のENUM */
enum HistoryProcessClass {
  laStartRegistration = '3',
  laCancelBeforeMaturity = '5',
  laContractInfoChange = '4',
  laArticleInfoChange = '1',
  reLeaseAndContractExpired = '6',
}

const historyProcessClassMap = new Map([
  ['1', HistoryProcessClass.laArticleInfoChange],
  ['3', HistoryProcessClass.laStartRegistration],
  ['4', HistoryProcessClass.laContractInfoChange],
  ['5', HistoryProcessClass.laCancelBeforeMaturity],
  ['6', HistoryProcessClass.reLeaseAndContractExpired],
]);

const rawValueToHistoryProcessClass = rawValueToEnumWithDefault(
  historyProcessClassMap,
  HistoryProcessClass.laStartRegistration,
);

const historyProcessClassToDisplay = enumToNameWithDefault(HistoryProcessClass, historyProcessClassConfig);

export { HistoryProcessClass, historyProcessClassToDisplay, rawValueToHistoryProcessClass };
